var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShuka(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 10,
    viewBox: "0 0 40 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.90255 1.37423C9.7674 1.37423 11.3093 2.76913 11.5276 4.56277L-0.000244141 4.56277L-0.000244141 5.43723L11.5276 5.43723C11.3093 7.23087 9.7674 8.62553 7.90255 8.62553H-0.000244141L-0.000244141 9.5H7.90255C10.2538 9.5 12.1922 7.71414 12.4144 5.43723H17.1828V6.47664L39.9998 6.47664V3.52324L17.1828 3.52324V4.56289H12.4144C12.1922 2.28598 10.2538 0.5 7.90255 0.5H-0.000244141L-0.000244141 1.37435H7.90255V1.37423ZM18.0638 4.39771L39.1188 4.39771V5.60217L18.0638 5.60217V4.39771Z",
    fill: "#DCCA87"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShuka);
export default __webpack_public_path__ + "static/media/shuka.93d9ced2d4ef8a21bce387082aa0118d.svg";
export { ForwardRef as ReactComponent };